module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.showable) ? _c('span', {
    staticClass: "tag",
    class: _vm.spanStateClass
  }, [(_vm.type == 'status') ? _c('i', {
    staticClass: "tag__prefix-icon"
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "tag__title"
  }, [_vm._t("default")], 2), _vm._v(" "), (_vm.type == 'text') ? _c('i', {
    staticClass: "tag__title--clear aid aid-close",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.$_onIClick($event)
      }
    }
  }) : _vm._e()]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2b0981c0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tag/tag.vue
// module id = 356
// module chunks = 0